// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2DwLu","alertIcon":"ConfirmModal_alertIcon__yI_M8"};